import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideAuth0, AuthHttpInterceptor } from '@auth0/auth0-angular';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { environment } from './environments/environment';

// Custom logging interceptor to check if requests are intercepted
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
} from '@angular/common/http';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // console.log('Intercepted Request:', req);
        return next.handle(req);
    }
}

bootstrapApplication(AppComponent, {
    providers: [
        ...appConfig.providers,
        provideHttpClient(withInterceptorsFromDi()),

        // Provide Auth0 Authentication
        provideAuth0({
            domain: environment.auth.domain,
            clientId: environment.auth.clientId,
            useRefreshTokens: environment.auth.useRefreshTokens,
            cacheLocation: 'localstorage',
            authorizationParams: {
                redirect_uri: window.location.origin + '/app/loading',
                audience: environment.auth.authorizationParams.audience,
                prompt: 'none',
            },
            httpInterceptor: {
                allowedList: ['/api/*'], // Ensure API requests get the token
            },
        }),

        // Provide Auth0 HTTP Interceptor
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },

        // Logging Interceptor for Debugging
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoggingInterceptor,
            multi: true,
        },
    ],
})
    .then(() => console.log(''))
    .catch(err => console.error('Bootstrap error:', err));

// Logging Auth Interceptor
